<template>
    <div class="main main-padding new-data-details">
        <div class="top-area">
            <!--返回-->
            <div class="main-back" v-if="$route.query.type!='bigData'">
                <div class="bank-back" v-on:click="gotoBack">
                    <img src="../../../../assets/images/back.png"/>
                    <p class="click-text">返回</p>
                </div>
            </div>
            <!--时间选择器-->
            <div class="time-select-picker">
                <div class="time-select">
                    <Row :gutter="10">
                        <date-select @updateDateTime="updateDateTime" ref="dateSelect"></date-select>
                    </Row>
                </div>
            </div>
        </div>
        <!--数据信息-->
        <card>
            <!--标题及搜索框-->
            <div class="details-card-header-area">
                <!--tab切换数据-->
                <div class="details-tab-data">
                    <span>活跃大屏具体使用详情</span>
                </div>
                <!--搜索框-->
                <div class="input-data">
                    <Input
                        v-model="keyWord"
                        placeholder="支持场景编码、行为编码关键字搜索"
                        icon="ios-search"
                        clearable
                        @on-enter="handleSearch"
                    >
                        <Button
                            slot="append"
                            icon="ios-search"
                            class="search-input-button"
                            @click="handleSearch"
                            type="primary"
                        ></Button>
                    </Input>
                </div>
            </div>
            <div>
                <!--活跃大屏具体使用详情-->
                <div class="table-wrapper-data">
                    <Table :columns="activeScreenDetailsColumn" :data="activeScreenDetailsList"></Table>
                </div>
                <!--分页,大屏重复绑定情况下不显示-->
                <div class="laypage_main">
                    <Page
                        :total="total"
                        :current="page"
                        :page-size="limit"
                        @on-change="handleCurrentChange"
                        v-show="total && pageCount>1"
                        show-total
                    />
                </div>
            </div>
        </card>
    </div>
</template>

<script>
    import {getScreenDataCodingList} from "../../../../service/api.js";
    import dateSelect from "../../../../components/dateSelect.vue";

    export default {
        name: "data-details-tab",
        data () {
            return {
                schoolId: this.$route.query.schoolId,
                startTime: this.$route.query.selfStartDate,//上一个页面选择的开始时间
                endTime: this.$route.query.selfEndDate,//上一个页面选择的结束时间
                selfStartDate: this.$route.query.selfStartDate,
                selfEndDate: this.$route.query.selfEndDate,
                parentalStartDate: this.$route.query.parentalStartDate,//主页面选择的结束时间
                parentalEndDate: this.$route.query.parentalEndDate,//主页面选择的结束时间
                diskId: this.$route.query.diskId,
                schoolName: this.$route.query.schoolName,
                tabsName: this.$route.query.tabsName,//tab名称
                isShowRemind: this.$route.query.isShowRemind,//是否显示重复绑定
                keyWord: "",
                page: 1,
                limit: 10,
                total: 0,//页面数据总数
                pageCount: 0,//页数
                activeScreenDetailsList:[],//活跃大屏具体使用详情
                activeScreenDetailsColumn: [
                    {
                        title: "序号",
                        key: "rowNum",
                        align: "center"
                    },
                    {
                        title: "场景编码",
                        key: "funcName",
                        align: "center"
                    },
                    {
                        title: "行为编码",
                        key: "cls_name",
                        align: "center"
                    },
                    {
                        title: "使用次数",
                        key: "count",
                        align: "center"
                    }
                ],
            }
        },
        components: {
            //时间选择组件
            dateSelect
        },
        methods: {
            /**
             *获取活跃大屏具体使用详情数据
             */
            async getScreenDataCodingList () {
                let _this = this;
                let params = {
                    schoolId: _this.schoolId,
                    startTime: _this.startTime,
                    endTime: _this.endTime,
                    diskId: _this.diskId,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await getScreenDataCodingList(params)
                    .then(function (data) {
                        if (Object.keys(data).length != 0) {
                            _this.activeScreenDetailsList = data.rows;
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 翻页
             */
            handleCurrentChange(val){
                this.page = val;
                this.getScreenDataCodingList();
            },
            /**
             * 翻页
             */
            handleSearch(){
                this.total = 0;
                this.page = 1;
                this.getScreenDataCodingList();
            },
            /**
             * 返回上一页
             */
            gotoBack () {
                this.$router.push({
                    name: "dataDetailsTab",
                    query: {
                        schoolId: this.schoolId,
                        parentalStartDate: this.selfStartDate,//二级页面选择的开始时间
                        parentalEndDate: this.selfEndDate,//二级页面选择的结束时间
                        curSeleMainStartDate: this.parentalStartDate,//一级页面选择的开始时间
                        curSeleMainEndDate: this.parentalEndDate,//一级页面选择的结束时间
                        schoolName: this.schoolName,
                        tabsName: this.tabsName,
                        isShowRemind: this.isShowRemind,
                        type:1
                    }
                });
            },
            /**
             * 更新开始时间结束时间
             */
            updateDateTime (startDate, endDate) {
                this.page=1;
                this.startTime = startDate;
                this.endTime = endDate;
                this.getScreenDataCodingList();
            }
        },
        mounted () {
            //修改公共属性学校名称
            this.$store.commit("SET_TOPHEADERNAME", this.schoolName);
            //获取班级安装大屏详情数据
            this.getScreenDataCodingList();
            //记住页面选择的开始和结束时间
            this.$refs.dateSelect.setDate(this.selfStartDate, this.selfEndDate);
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../style/home";
    @import "../../../../style/dataDetails";
</style>
<style lang="scss">
    .new-data-details {
        .ivu-input-group {
            width: 300px;
            float: right;
        }

        .ivu-card-body {
            padding: 16px;
        }

        .ivu-input-group-append .ivu-btn, .ivu-input-group-prepend .ivu-btn {
            color: #fff;
            background: #57a3f3;
        }

        .ivu-input-group .ivu-input {
            font-size: 14px;
        }

        .ivu-btn-icon-only {
            border-radius: 0 4px 4px 0;
        }
        .time-slot .ivu-col-span-lg-4 {
            display: block;
            width: 355px;
        }
        .ivu-row {
            margin-top: 0 !important;
        }
        .ivu-input-icon-clear {
            margin-right: 45px;
        }

        .ivu-table {
            font-size: 14px;
        }

        .ivu-tabs-nav {
            font-size: 14px;
        }
        .ivu-table-overflowX {
            overflow-x: hidden;
        }
    }
</style>
